import React from 'react';
import { Link } from 'react-router-dom';

/** Top-level desktop nav link with active-state styling. */
export const NavLink = ({ to, isActive, children }) => (
  <Link
    to={to}
    className={`px-4 py-2 rounded-lg font-medium transition-colors ${
      isActive
        ? 'text-church-green bg-green-50'
        : 'text-slate-700 hover:text-church-green hover:bg-green-50'
    }`}
  >
    {children}
  </Link>
);
